import moment from "moment"; 

export default function getValidSlots (slots) { 
    const cutoff = getCutoffTime();
    return slots.filter((slot) => { 
      const slotDateTime = moment(`${slot.slotDate} ${slot.slotTime}`) 
      return slotDateTime.isAfter(cutoff); 
    }) 
  } 

// Calculation to exclude weekend in 25 hour delay. If today is weekend then start delay from midnight monday.
function getCutoffTime() {
  const today = moment();
  const day = today.day();
  if (day >= 1 && day <= 4) {
    return today.add(25, 'hours');
  }
  if (day === 5) {
    return today.add(73, 'hours');
  }
  const daysUntilMonday = day === 6 ? 2 : 1;
  const nextMondayMidnight = today.add(daysUntilMonday, 'days').startOf('day');
  return nextMondayMidnight.add(25, 'hours');
};